"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DropDown_1 = __importDefault(require("../../../../common/DropDown/DropDown"));
function SortingSelector(props) {
    var i18n = (0, react_i18next_1.useTranslation)().i18n, getCurrentLang = i18n.language, _a = (0, react_1.useState)([]), categoryArr = _a[0], setCategoryArr = _a[1];
    (0, react_1.useEffect)(function () {
        if (props.list && props.list.length > 0) {
            var output_1 = [];
            props.list.map(function (item) {
                var id = item.id, value = (item === null || item === void 0 ? void 0 : item.sorting) ? item.sorting : item.order_by, label = Object.prototype.hasOwnProperty.call(item, "title")
                    ? "before ".concat(JSON.parse(item.title)[getCurrentLang])
                    : "before ".concat(JSON.parse(item.name)[getCurrentLang]), sorting_id = item.sorting;
                output_1.push({
                    id: id,
                    value: value,
                    label: lodash_1.default.truncate(label, {
                        length: 30,
                        omission: " ...",
                    }),
                    sorting_id: sorting_id,
                });
            });
            setCategoryArr(output_1);
        }
    }, [props.list, getCurrentLang]);
    return (react_1.default.createElement(DropDown_1.default, { defaultValue: props.value, error: props.error, 
        // label={t("sorting_order")}
        label: props.label, 
        // label={t(props.label)}
        name: "sorting_order", onChange: function (e) {
            props.onChange(e);
        }, options: categoryArr, value: props.value }));
}
SortingSelector.propTypes = {
    error: prop_types_1.default.any,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    label: prop_types_1.default.any,
    list: prop_types_1.default.any,
    value: prop_types_1.default.any,
    onChange: prop_types_1.default.any,
};
exports.default = SortingSelector;
